import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

export const ContactSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  return (
    <section id="contact" className="py-20 bg-navy-900 text-white">
      <div className="max-w-4xl mx-auto px-4">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 20 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <h2 className="text-4xl font-bold mb-6 animate-fade-up">Contact Us</h2>
          <p className="text-xl mb-8 animate-fade-up">Ready to create your perfect montage?</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <motion.div 
              whileHover={{ scale: 1.05 }}
              className="bg-navy-800/50 p-6 rounded-lg transform transition-all duration-300 hover:shadow-lg"
            >
              <h3 className="text-xl font-semibold mb-4">Customer Support</h3>
              <p className="mb-4">Our team is here to help you create the perfect video montage</p>
            </motion.div>
            <motion.div 
              whileHover={{ scale: 1.05 }}
              className="bg-navy-800/50 p-6 rounded-lg transform transition-all duration-300 hover:shadow-lg"
            >
              <h3 className="text-xl font-semibold mb-4">Quick Response</h3>
              <p className="mb-4">We typically respond to all inquiries within 2-4 hours</p>
            </motion.div>
          </div>
          <motion.a
            whileHover={{ scale: 1.05 }}
            href="mailto:mymontage.video@gmail.com"
            className="text-2xl text-blue-300 hover:text-blue-200 transition-colors inline-block"
          >
            mymontage.video@gmail.com
          </motion.a>
        </motion.div>
      </div>
    </section>
  );
};